import { QueryConfig } from "store/utils/query-config";

export const NPSSubmissionsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
